import { render } from "./AllenView.vue?vue&type=template&id=df19c4da&scoped=true"
import script from "./AllenView.vue?vue&type=script&lang=js"
export * from "./AllenView.vue?vue&type=script&lang=js"

import "./AllenView.vue?vue&type=style&index=0&id=df19c4da&scoped=true&lang=css"
import "./AllenView.vue?vue&type=style&index=1&id=df19c4da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df19c4da"]])

export default __exports__